import './index.scss';

import { Component, ReactNode } from 'react';

import strings from 'utils/strings';
import { UncontrolledField } from '..';
import { BraxSelectOption } from '../BraxUncontrolledSelectField';
import { BraxUncontrolledTextField } from '../BraxUncontrolledTextField';
import { BraxListItem } from '../../BraxList';
import { BraxDropdown } from '../../BraxDropdown';
import { BraxIcon } from '../../BraxIcon';

export type BraxAutocompleteOption = BraxSelectOption<string> & {
    search?: string
};

export type BraxUncontrolledAutocompleteFieldProps = UncontrolledField<string> & {
    label: ReactNode
    placeholder?: string,
    hint?: ReactNode,
    options: BraxAutocompleteOption[],
    required?: boolean,
    onChange?: (value: string) => void
};

type BraxUncontrolledAutocompleteFieldState = {
    options: BraxListItem[]
};

export class BraxUncontrolledAutocompleteField extends Component<BraxUncontrolledAutocompleteFieldProps, BraxUncontrolledAutocompleteFieldState> {

    static defaultProps = {
        placeholder: '',
        disabled: false,
        status: null
    };

    state: BraxUncontrolledAutocompleteFieldState = {
        options: []
    };

    componentDidMount() {
        this.updateOptions();
    }

    componentDidUpdate(prevProps: BraxUncontrolledAutocompleteFieldProps) {
        if (prevProps.options !== this.props.options || prevProps.value !== this.props.value)
            this.updateOptions();
    }

    updateOptions() {
        const options: BraxListItem[] = [];

        for (const { value, search, ...option } of this.props.options) {
            const searchTerm = this.props.value ? strings.normalize(this.props.value) : undefined;

            if (
                !searchTerm ||
                (search && strings.normalize(search).includes(searchTerm)) ||
                strings.normalize(value).includes(searchTerm)
            )
                options.push({ ...option, onSelect: () => this.props.onChange?.(value) });
        }

        if (options.length === 0)
            options.push({
                title: this.props.value!,
                onSelect: () => this.props.onChange?.(this.props.value!)
            });

        this.setState({ options });
    }

    blur = () => document.body.click();

    render() {
        const { options, value, ...props } = this.props;

        return (
            <div className="brax-autocomplete-field">
                <BraxDropdown
                    items={this.state.options}
                    disabled={props.disabled}
                    position="bottom-left"
                    noButton
                >
                    <BraxUncontrolledTextField value={value as any} {...props} onBlur={this.blur} />

                    <BraxIcon icon="arrow" />
                </BraxDropdown>
            </div>
        );
    }

}
